import * as React from 'react';
import { cn } from '@/lib/utils';

export interface ContainerIconProps extends Omit<React.SVGProps<SVGSVGElement>, 'strokeWidth'> {
  size?: number | string;
}

export function ContainerIcon({ size, className, style, ...props }: ContainerIconProps) {
  const sizeStyles = size ? { width: size, height: size } : {};

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('shrink-0', className)}
      style={{ ...style, ...sizeStyles }}
      {...props}
    >
      <path
        d="M22.2656 6.26246L12.3094 3.41809C12.1571 3.37486 11.9974 3.36401 11.8406 3.38621L1.98469 4.79246C1.53839 4.85822 1.13048 5.08191 0.835103 5.42287C0.539722 5.76384 0.376466 6.19947 0.375 6.65059V17.3493C0.376914 17.8001 0.540372 18.2353 0.835712 18.5759C1.13105 18.9165 1.5387 19.1399 1.98469 19.2056L11.8406 20.6118C11.8934 20.6194 11.9467 20.6231 12 20.6231C12.1046 20.6232 12.2088 20.6087 12.3094 20.58L22.2656 17.7375C22.6561 17.6243 22.9995 17.3879 23.2446 17.0635C23.4896 16.739 23.623 16.344 23.625 15.9375V8.06246C23.6232 7.65587 23.4898 7.26078 23.2448 6.93632C22.9997 6.61185 22.6562 6.37545 22.2656 6.26246ZM8.625 10.875H7.875V6.2259L10.875 5.79746V18.2025L7.875 17.774V13.125H8.625C8.92337 13.125 9.20952 13.0064 9.42049 12.7955C9.63147 12.5845 9.75 12.2983 9.75 12C9.75 11.7016 9.63147 11.4154 9.42049 11.2045C9.20952 10.9935 8.92337 10.875 8.625 10.875ZM2.625 6.9759L5.625 6.54746V10.875H4.875C4.57663 10.875 4.29048 10.9935 4.0795 11.2045C3.86853 11.4154 3.75 11.7016 3.75 12C3.75 12.2983 3.86853 12.5845 4.0795 12.7955C4.29048 13.0064 4.57663 13.125 4.875 13.125H5.625V17.4525L2.625 17.024V6.9759ZM21.375 15.6562L13.125 18.0131V5.99152L21.375 8.3484V15.6562Z"
        fill="currentColor"
      />
    </svg>
  );
}
